/* eslint-disable sonarjs/cognitive-complexity */
import { Process, Segment } from "@/types/contract";
import { Product } from "@/types/enumerations";
import type { ProcessReasonType } from "@/types/processReason";
import { isOverFlowContract } from "@/utils/product";

interface ListKeyProps {
  process: Process;
  selfService: boolean | null;
  isPSProcessRequest: boolean;
  isPSContractPreparation: boolean;
  isS3NewCustomerProcess: boolean;
  processReason?: ProcessReasonType;
  product?: Product | null;
  phase?: string | null;
  segment?: Segment;
}

export const listKey = ({
  process,
  selfService,
  isPSProcessRequest,
  isPSContractPreparation,
  isS3NewCustomerProcess,
  processReason,
  product,
  phase,
  segment,
}: ListKeyProps) => {
  const isVRTProcess = process === Process.VRB && isOverFlowContract(product?.id);
  const isTCRMoveOut = process === Process.TCR && processReason === "move_out";
  const isTCRDismantling = process === Process.TCR && processReason === "demontage_01";
  const isTCRDeath = process === Process.TCR && processReason === "demontage_02";
  const isPSRequestDeath = isPSProcessRequest && processReason === "02";
  const isPSRequestIdeal = isPSProcessRequest && processReason === "01";
  const isPSDraft = process === Process.PS && phase === "draft";

  if (isS3NewCustomerProcess) {
    return `list.S3NewCustomer` as const;
  }
  if (isPSDraft) {
    return `list.PSDraft` as const;
  }
  if (isVRTProcess) {
    return `list.VRT.${selfService ? "selfService" : "noSelfService"}` as const;
  }
  if (isTCRMoveOut) {
    return `list.TCR_moveOut.${selfService ? "selfService" : "noSelfService"}` as const;
  }
  if (isTCRDismantling) {
    return `list.TCR_demontage_01.${selfService ? "selfService" : "noSelfService"}` as const;
  }
  if (isTCRDeath) {
    return `list.TCR_demontage_02.${selfService ? "selfService" : "noSelfService"}` as const;
  }
  if (isPSRequestDeath) {
    return `list.PSRequestDeath` as const;
  }
  if (isPSRequestIdeal) {
    return `list.PSRequestIdeal` as const;
  }
  if (isPSContractPreparation) {
    if (segment === Segment.B2B && processReason === "02") {
      return `list.PSContractRequestB2BDeath` as const;
    }
    return `list.PSContractRequest` as const;
  }
  if (process === Process.PS && selfService && segment === Segment.B2B && processReason === "02") {
    return `list.PS.selfServiceB2BDeath` as const;
  } else {
    return `list.${process}.${selfService ? "selfService" : "noSelfService"}` as const;
  }
};
